import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { InteractionTypeListResponseData } from "../../types/interaction";

export const getData = async () => {
  const { data } = await api.get<InteractionTypeListResponseData>(
    `/interactions/get-types`,
  );

  return data;
};

export const useInteractionTypes =
  (): QueryObserverBaseResult<InteractionTypeListResponseData> => {
    const { data, ...props } = useQuery(queryKeys.interactionTypes(), () =>
      getData(),
    );
    return { data, ...props };
  };
